import styled, { css } from "styled-components";

interface HomepageHeaderArenaTileBoxProps {
    useSmallHeaderArenas: boolean;
    totalItemsCount: number;
}

export const HomepageHeaderArenaTileDefaultBox = styled.div<HomepageHeaderArenaTileBoxProps>`
  display: inline-block;
  width: 20%;
  ${props => props.useSmallHeaderArenas ? css`max-width: 290px` : ""};
  transition: transform 0.4s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    max-width: ${({totalItemsCount}) => 100 / totalItemsCount}%;
    &::after {
      content: "";
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 15px;
      background-image: url(${props => props.theme.images.headerArenaTileDropShadow.toString()});
      background-repeat: no-repeat;
      background-position: center;
      transform: translateY(100%);
      z-index: 0;
    }
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width: 22%;
    ${props => props.useSmallHeaderArenas ? css`max-width: 210px` : ""};
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    width: ${props => !props.useSmallHeaderArenas ? "45%" : "31%"};
    ${props => props.useSmallHeaderArenas ? css`min-width: 100px;`: ""};
  }

`;
